module.exports = __webpack_public_path__ + "static/media/mps1_v3.fb57cf4d.jpg";